import { ReactNode } from 'react';
import { RequestsChart, RequestsChartProps } from '../RequestsChart';
import { IChartData } from '../Chart';
import { Timeframe, TranslationRequestWidget } from '../../types';
import { SxProps, Theme } from '@mui/material';
import { Title } from '../Title';

export interface RequestsWidgetProps {
  NoDataPlaceholder: RequestsChartProps['NoDataPlaceholder'];
  className?: string;
  data: IChartData[];
  isLoading: boolean;
  sx?: SxProps<Theme>;
  timeframe: Timeframe;
  translation?: TranslationRequestWidget;
  isTitleHidden?: boolean;
  csvButton?: ReactNode;
}

export const RequestsWidget = ({
  NoDataPlaceholder,
  sx,
  className,
  data = [],
  timeframe,
  isLoading,
  translation = {
    date: (value: Date) => `date ${value}`,
    time: (value: Date) => `time ${value}`,
    callsCount: (value: number) => `callsCount ${value}`,
    title: 'TitlePlaceholder',
  },
  isTitleHidden,
  csvButton,
}: RequestsWidgetProps) => {
  return (
    <RequestsChart
      NoDataPlaceholder={NoDataPlaceholder}
      className={className}
      isLoading={isLoading}
      timeframe={timeframe}
      data={data}
      sx={sx}
      translation={translation}
      title={
        !isTitleHidden && (
          <Title csvButton={csvButton}>{translation.title}</Title>
        )
      }
    />
  );
};
